module.exports = __webpack_public_path__ + "media/sk_sk_s1_Dalenka.ea021b05.mp3";